<div *ngIf="loadedItems" class="vit-vital-sign-chart">
  <ng-container *ngIf="!dataValues?.length; else vitalSignChart">
    <div class="vit-vital-sign-chart_empty d-flex flex-column align-items-center">
      <img src="assets/images/no_chart.svg" width="252">
      <span class="mt-2 text-center">{{'SI_NO_VITAL_SIGN_RECORDED' | translate}}</span>
    </div>
  </ng-container>
  <ng-template #vitalSignChart>
    <div>
      <p-chart type="line" [data]="chartData" [options]="chartOptions" [height]="chartHeight"></p-chart>
    </div>
  </ng-template>
</div>
